@if (confirm.visible()) {
  <div class="cd-scrim" (click)="confirm.resolve(false)"></div>
  <div class="confirm-box" role="dialog" aria-modal="true">
    <div class="cd-icon" [class.danger]="confirm.options().danger">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    </div>
    <h3 class="cd-title">{{ confirm.options().title ?? 'Confirm Action' }}</h3>
    <p class="cd-msg">{{ confirm.options().message }}</p>
    <div class="cd-actions">
      <button class="btn" (click)="confirm.resolve(false)">
        {{ confirm.options().cancelLabel ?? 'Cancel' }}
      </button>
      <button class="btn" [class.btn-danger]="confirm.options().danger" [class.btn-primary]="!confirm.options().danger" (click)="confirm.resolve(true)">
        {{ confirm.options().confirmLabel ?? 'Confirm' }}
      </button>
    </div>
  </div>
}
